// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageDotsLoader_loader__8DJrV"};